import React from "react";

/**
 * Clean PlacesInput implementation.
 */
const PlacesInput = ({
  inputNode,
  iconNode,
  value,
  onClear,
  containerStyle = {},
  showClearAsButton = true,
  extraBefore = null,
  ariaLabelClear = "Clear input",
}) => {
  return (
    <div>
      {/* Label rendered outside / above the input container so it sits on top-left */}
      {extraBefore ? (
        <div className="mt-1 mb-1 text-base font-bold text-[#211F59]">
          {extraBefore}:
        </div>
      ) : null}

      <div
        className={`relative flex items-center font-instrument font-[16px] bg-[#E6E6E6] text-[#373559] rounded-[15px] py-2.5 px-3 h-12 gap-2 border border-transparent focus-within:border-[#7876A1] focus-within:ring-0 focus-within:shadow-[0_0_0_1px_#7876A1] transition-all duration-150`}
        style={containerStyle}
      >
        {/* Left icon or small area */}
        <div className="flex-shrink-0">{iconNode}</div>

        {/* Input node provided by caller (can be a raw <input> with getInputProps spread) */}
        <div className="flex-1">{inputNode}</div>

        {/* Clear button shown only when there is a value and onClear provided */}
        {showClearAsButton && value ? (
          <button
            aria-label={ariaLabelClear}
            onClick={onClear}
            className="bg-transparent border-0 p-1.5 flex items-center justify-center cursor-pointer"
          >
            <img
              src="/images/NewUiIcons/CloseMini.svg"
              alt="close"
              className="w-[16.74px] h-[16.74px] cursor-pointer"
            />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PlacesInput;
